import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environment/environment';
import CustomTheme from '../style/vendor/primeng/themes/custom-theme/custom-theme';
import { httpInterceptors } from './core/config/http-interceptors';
import { ConfirmationService, MessageService } from 'primeng/api';
import { appRoutes } from './app.routes';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateConfig } from './core/config/translate.config';
import { provideStore, Store } from '@ngxs/store';
import {
  ngxsConfig,
  ngxsStates,
  ngxsStorageConfig,
} from './core/config/ngxs.config';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import en from '@angular/common/locales/en-GB';
import { registerLocaleData } from '@angular/common';
import { DynamicLocaleId } from './shared/common/dynamic-locale-id';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-angular19';

registerLocaleData(en, 'en');

const globalServices = [
  { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [Store] },
  MessageService,
  ConfirmationService,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    TranslateModule.forRoot(TranslateConfig).providers!,
    providePrimeNG({
      ripple: false,
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order:
              'normalize, app-styles, primeng, primeicons, primeflex, custom',
          },
        },
      },
    }),
    provideStore(
      ngxsStates,
      ngxsConfig,
      withNgxsStoragePlugin(ngxsStorageConfig),
      withNgxsRouterPlugin()
    ),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      //@ts-ignore
      useValue: environment.recaptchaToken,
    },
    ...httpInterceptors,
    ...globalServices,
  ],
};
